import * as i0 from '@angular/core';
import { Directive, Input, HostListener, Attribute, NgModule, Component, HostBinding, EventEmitter, Output, Injectable, ViewChild } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@anthem/uxd/util';
import { UxHelper, getFocusableBoundaryElements, focusTrap, UxEvents } from '@anthem/uxd/util';

//istanbul ignore next
class BlockToggleDirective {
    constructor(_element, renderer) {
        this._element = _element;
        this.renderer = renderer;
        this._jElement = this._element.nativeElement;
        this.blockOpen = false;
        this.startBlockExpanded = false;
    }
    ngOnInit() {
        //no-op
        this.blockOpen = this.startBlockExpanded;
    }
    onClick() {
        this._parentElement = this._jElement.parentElement.parentElement;
        this._limitOneHeader = this._parentElement.classList.contains('limit-one-collapse');
        if (this._limitOneHeader) {
            if (this._parentElement.classList.contains('ant-block-expanded')) {
                this.removeExpandClass();
            }
            else {
                let activeBlocks = this._parentElement.getElementsByClassName('ant-block-expanded');
                if (activeBlocks.length > 0) {
                    activeBlocks[0].classList.remove('ant-block-expanded');
                }
                this.addExpandClass();
            }
        }
        else {
            this._parentElement.classList.toggle('ant-block-expanded');
            this.blockOpen = !this.blockOpen;
        }
    }
    onKeydown(e) {
        let key = e.which || e.keyCode;
        if (key === 13) {
            this.onClick();
        }
    }
    addExpandClass() {
        this._parentElement.classList.add('ant-block-expanded');
        this.blockOpen = true;
    }
    removeExpandClass() {
        this._parentElement.classList.remove('ant-block-expanded');
        this.blockOpen = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BlockToggleDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: BlockToggleDirective, selector: "[data-uxd-block-toggle-dir]", inputs: { startBlockExpanded: "startBlockExpanded" }, host: { attributes: { "tabindex": "0" }, listeners: { "click": "onClick()", "keydown": "onKeydown($event)" }, properties: { "attr.aria-expanded": "blockOpen" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BlockToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-block-toggle-dir]',
                    host: {
                        tabindex: '0',
                        '[attr.aria-expanded]': 'blockOpen'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { startBlockExpanded: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

//istanbul ignore next
class RowToggleDirective {
    constructor(
    // @Attribute('data-out-class') private _outClass: string,
    // @Attribute('data-in-class') private _inClass: string,
    _id, _name, _element, renderer) {
        this._id = _id;
        this._name = _name;
        this._element = _element;
        this.renderer = renderer;
        this._jElement = $(this._element.nativeElement);
        // _outClass = _outClass || 'fa-minus-circle';
        // _inClass = _inClass || 'fa-plus-circle';
    }
    ngOnInit() {
        //no-op
    }
    ngAfterViewInit() {
        this._toggleCtrl = this._jElement.find('.ant-toggle-ctrl');
        this._toggleBody = this._jElement.find('.ant-toggle-body');
        this._toggleCtrlGlyph = this._jElement.find('.ant-toggle-ctrl .fa');
        this._inClass = 'fa-minus-circle';
        this._outClass = 'fa-plus-circle';
        this._toggleCtrl.on('click', () => {
            this.toggleBlock();
        });
    }
    toggleBlock() {
        if (!this._toggleBody.hasClass('in')) {
            this._toggleBody.addClass('in');
            this._toggleCtrl.removeClass('collapsed');
            this._toggleCtrlGlyph.removeClass(this._outClass);
            this._toggleCtrlGlyph.addClass(this._inClass);
            this._toggleCtrl.attr('aria-expanded', 'true');
        }
        else {
            this._toggleBody.removeClass('in');
            this._toggleCtrl.addClass('collapsed');
            this._toggleCtrlGlyph.removeClass(this._inClass);
            this._toggleCtrlGlyph.addClass(this._outClass);
            this._toggleCtrl.attr('aria-expanded', 'false');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RowToggleDirective, deps: [{ token: 'id', attribute: true }, { token: 'name', attribute: true }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: RowToggleDirective, selector: "[data-uxd-row-toggle-dir]", inputs: { _modelValue: ["ngModel", "_modelValue"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RowToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-row-toggle-dir]'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['id']
                }] }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ['name']
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { _modelValue: [{
                type: Input,
                args: ['ngModel']
            }] } });

class AccordianCmpDepModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccordianCmpDepModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AccordianCmpDepModule, declarations: [BlockToggleDirective, RowToggleDirective], imports: [CommonModule], exports: [BlockToggleDirective, RowToggleDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccordianCmpDepModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccordianCmpDepModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [BlockToggleDirective, RowToggleDirective],
                    exports: [BlockToggleDirective, RowToggleDirective]
                }]
        }] });

//istanbul ignore next
//alertCmp depricated use alertCmpV2
class AlertComponent {
    constructor(alertType) {
        this.alertType = alertType;
    }
    ngOnInit() {
        // init
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertComponent, deps: [{ token: 'data-alert-type', attribute: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AlertComponent, selector: "[data-uxd-alert-cmp]", ngImport: i0, template: `<div class="ant-anthem-alert" role="alert" aria-live="assertive" [ngClass]="{'ant-negative': (alertType === 'negative'), 'ant-positive': (alertType === 'positive')}">
              <div class="media">
                <div class="media-left media-top">
                  <span class="fa " [ngClass]="{'fa-info-circle': (!alertType || alertType === 'information'), 'fa-check-circle': (alertType === 'positive'), 'fa-exclamation-circle': (alertType === 'negative')}"></span>
                </div>
                <div class="media-body media-middle ">
                  <p>
                    <ng-content></ng-content>
                  </p>
                </div>
              </div>
            </div>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-alert-cmp]',
                    template: `<div class="ant-anthem-alert" role="alert" aria-live="assertive" [ngClass]="{'ant-negative': (alertType === 'negative'), 'ant-positive': (alertType === 'positive')}">
              <div class="media">
                <div class="media-left media-top">
                  <span class="fa " [ngClass]="{'fa-info-circle': (!alertType || alertType === 'information'), 'fa-check-circle': (alertType === 'positive'), 'fa-exclamation-circle': (alertType === 'negative')}"></span>
                </div>
                <div class="media-body media-middle ">
                  <p>
                    <ng-content></ng-content>
                  </p>
                </div>
              </div>
            </div>`
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['data-alert-type']
                }] }]; } });

class AlertCmpModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertCmpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AlertCmpModule, declarations: [AlertComponent], imports: [CommonModule], exports: [AlertComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertCmpModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertCmpModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [AlertComponent],
                    exports: [AlertComponent]
                }]
        }] });

//istanbul ignore next
class CalloutBlockComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CalloutBlockComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CalloutBlockComponent, selector: "[data-uxd-callout-block-cmp]", inputs: { calloutContent: "calloutContent" }, ngImport: i0, template: `
    <div class="ant-content-callout clearfix" [ngClass]="calloutContent.class">
      <div *ngFor="let callout of calloutContent.item">
        <div class="ant-callout-img-wrapper">
          <img [src]="callout.img" *ngIf="callout.img" />
          <span class="fa" [ngClass]="callout.icon" *ngIf="callout.icon"></span>
        </div>
        <div class="ant-callout-content">
          <h3>{{ callout.title }}</h3>
          <div class="ant-callout-body" [innerHTML]="callout.body"></div>
          <a [href]="callout.linkUrl">{{ callout.linkText }}</a>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CalloutBlockComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-callout-block-cmp]',
                    template: `
    <div class="ant-content-callout clearfix" [ngClass]="calloutContent.class">
      <div *ngFor="let callout of calloutContent.item">
        <div class="ant-callout-img-wrapper">
          <img [src]="callout.img" *ngIf="callout.img" />
          <span class="fa" [ngClass]="callout.icon" *ngIf="callout.icon"></span>
        </div>
        <div class="ant-callout-content">
          <h3>{{ callout.title }}</h3>
          <div class="ant-callout-body" [innerHTML]="callout.body"></div>
          <a [href]="callout.linkUrl">{{ callout.linkText }}</a>
        </div>
      </div>
    </div>
  `
                }]
        }], propDecorators: { calloutContent: [{
                type: Input
            }] } });

class CardComponent {
    constructor(_elRef) {
        this._elRef = _elRef;
        this.card = true; // card class on container
        this.tabindex = -1; // code focusable for accessibility
    }
    ngOnInit() {
        if (!this.cardConfig.isHidden) {
            this.hidden = false;
        }
        if (!this.cardConfig.isTabIndex) {
            this.tabindex = undefined;
        }
        if (this.cardConfig.title === '') {
            this.showTitle = false;
        }
        else {
            this.showTitle = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CardComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CardComponent, selector: "[data-uxd-card-cmp]", inputs: { cardConfig: "cardConfig" }, host: { properties: { "class.data-uxd-card": "this.card", "attr.tabindex": "this.tabindex", "class.hidden": "this.hidden" } }, ngImport: i0, template: `
    <h2 *ngIf="showTitle" class="card-title" [innerHTML]="cardConfig.title" [id]="cardConfig.cardId + '_title'"></h2>
    <div class="row" [id]="cardConfig.cardId + '_content-container'">
      <div class="col-xs-12 col-xxs-12">
        <ng-content>
        </ng-content>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-card-cmp]',
                    template: `
    <h2 *ngIf="showTitle" class="card-title" [innerHTML]="cardConfig.title" [id]="cardConfig.cardId + '_title'"></h2>
    <div class="row" [id]="cardConfig.cardId + '_content-container'">
      <div class="col-xs-12 col-xxs-12">
        <ng-content>
        </ng-content>
      </div>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { cardConfig: [{
                type: Input
            }], card: [{
                type: HostBinding,
                args: ['class.data-uxd-card']
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], hidden: [{
                type: HostBinding,
                args: ['class.hidden']
            }] } });

class CardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CardModule, declarations: [CardComponent], imports: [CommonModule], exports: [CardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CardModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CardComponent],
                    exports: [CardComponent]
                }]
        }] });

const modalConfigDefaults = {
    backdrop: true,
    keyboard: false,
    focus: true,
    show: true,
    ignoreBackdropClick: true
};
const modalClassNames = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    IN: 'in',
    ACTIVE: 'active' // bs4
};
const modalSelectors = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed'
};

class ModalBackdropOptions {
    constructor(options) {
        this.animate = true;
        Object.assign(this, options);
    }
}
//istanbul ignore next
class ModalBackdropComponent {
    get isAnimated() {
        return this._isAnimated;
    }
    set isAnimated(value) {
        this._isAnimated = value;
        if (value) {
            this.renderer.addClass(this.element.nativeElement, `${modalClassNames.FADE}`);
        }
        else {
            this.renderer.removeClass(this.element.nativeElement, `${modalClassNames.FADE}`);
        }
    }
    get isShown() {
        return this._isShown;
    }
    set isShown(value) {
        this._isShown = value;
        if (value) {
            this.renderer.addClass(this.element.nativeElement, `${modalClassNames.IN}`);
            this.renderer.addClass(this.element.nativeElement, `${modalClassNames.ACTIVE}`);
        }
        else {
            this.renderer.removeClass(this.element.nativeElement, `${modalClassNames.IN}`);
            this.renderer.removeClass(this.element.nativeElement, `${modalClassNames.ACTIVE}`);
        }
    }
    constructor(options, element, renderer) {
        this._isShown = false;
        this.element = element;
        this.renderer = renderer;
        this.isAnimated = options.animate !== false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalBackdropComponent, deps: [{ token: ModalBackdropOptions }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ModalBackdropComponent, selector: "[data-uxd-modal-backdrop]", host: { classAttribute: "modal-backdrop" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalBackdropComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-modal-backdrop]',
                    template: '',
                    host: { class: modalClassNames.BACKDROP }
                }]
        }], ctorParameters: function () { return [{ type: ModalBackdropOptions }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

// todo: in original bs there are was a way to prevent modal from showing
// todo: original modal had resize events
const TRANSITION_DURATION = 300;
const BACKDROP_TRANSITION_DURATION = 150;
//istanbul ignore next
class ModalDirective {
    set config(conf) {
        this._config = this.getConfig(conf);
    }
    get config() {
        return this._config;
    }
    get isShown() {
        return this._isShown;
    }
    get document() {
        return this.componentsHelper.getDocument();
    }
    /** Host element manipulations */
    // @HostBinding(`class.${ClassName.IN}`) protected _addClassIn:boolean;
    onClick(event) {
        if (this.config.ignoreBackdropClick || this.config.backdrop === 'static' || event.target !== this._hostElement.nativeElement) {
            return;
        }
        this.hide(event);
    }
    // todo: consider preventing default and stopping propagation
    onEsc() {
        if (this.config.keyboard) {
            this.hide();
        }
    }
    //tslint:disable
    constructor(_hostElement, renderer, componentsHelper) {
        this._hostElement = _hostElement;
        this.renderer = renderer;
        this.componentsHelper = componentsHelper;
        this.onShow = new EventEmitter();
        this.onShown = new EventEmitter();
        this.onHide = new EventEmitter();
        this.onHidden = new EventEmitter();
        // seems like an Options
        this.isAnimated = true;
        this._isShown = false;
        this.isBodyOverflowing = false;
        this.originalBodyPadding = 0;
        this.scrollbarWidth = 0;
        this.timerHideModal = 0;
        this.timerRmBackDrop = 0;
        this.hasOpened = false;
    }
    //tslint:enable
    ngOnDestroy() {
        this.config = void 0;
        if (this._isShown) {
            this._isShown = false;
            this.hideModal();
        }
        this._isShown = void 0;
        this.isBodyOverflowing = void 0;
        this.originalBodyPadding = void 0;
        this.scrollbarWidth = void 0;
        this.timerHideModal = void 0;
        this.timerRmBackDrop = void 0;
        if (typeof this._hostElement.nativeElement.remove !== 'undefined' && this.hasOpened) {
            this._hostElement.nativeElement.remove();
        }
        else if (this.document.body.contains(this._hostElement.nativeElement) && this.hasOpened) {
            this.document.body.removeChild(this._hostElement.nativeElement);
        }
    }
    ngAfterViewInit() {
        this._config = this._config || this.getConfig();
    }
    /** methods */
    toggle( /*relatedTarget?:ViewContainerRef*/) {
        return this._isShown ? this.hide() : this.show( /*relatedTarget*/);
    }
    show( /*relatedTarget?:ViewContainerRef*/) {
        if (document.activeElement) {
            this._prevFocusedElem = document.activeElement;
        }
        this.hasOpened = true;
        if (this.onShow) {
            this.onShow.emit(this);
        }
        if (this._isShown) {
            return;
        }
        clearTimeout(this.timerHideModal);
        clearTimeout(this.timerRmBackDrop);
        this._isShown = true;
        this.checkScrollbar();
        this.setScrollbar();
        if (this.document && this.document.body) {
            this.renderer.addClass(this.document.body, modalClassNames.OPEN);
        }
        this.showBackdrop(() => {
            this.showElement( /*relatedTarget*/);
        });
    }
    hide(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.onHide) {
            this.onHide.emit(this);
        }
        // todo: add an option to prevent hiding
        if (!this._isShown) {
            return;
        }
        clearTimeout(this.timerHideModal);
        clearTimeout(this.timerRmBackDrop);
        this._isShown = false;
        this.renderer.removeClass(this._hostElement.nativeElement, modalClassNames.IN);
        this.renderer.removeClass(this._hostElement.nativeElement, modalClassNames.ACTIVE);
        // this._addClassIn = false;
        if (this.isAnimated) {
            this.timerHideModal = setTimeout(() => this.hideModal(), TRANSITION_DURATION);
        }
        else {
            this.hideModal();
        }
    }
    /** Private methods */
    getConfig(config) {
        return Object.assign({}, modalConfigDefaults, config);
    }
    /**
     *  Show dialog
     */
    showElement( /*relatedTarget?:ViewContainerRef*/) {
        // todo: replace this with component helper usage `add to root`
        //if (!this.element.nativeElement.parentNode ||
        //(this.element.nativeElement.parentNode.nodeType !== Node.ELEMENT_NODE)) {
        // don't move modals dom position
        if (this.document && this.document.body) {
            this.document.body.appendChild(this._hostElement.nativeElement);
        }
        //}
        this.renderer.setStyle(this._hostElement.nativeElement, 'display', 'block');
        this.renderer.setProperty(this._hostElement.nativeElement, 'scrollTop', 0);
        if (this.isAnimated) {
            UxHelper.reflow(this._hostElement.nativeElement);
        }
        // this._addClassIn = true;
        this.renderer.addClass(this._hostElement.nativeElement, modalClassNames.IN);
        this.renderer.addClass(this._hostElement.nativeElement, modalClassNames.ACTIVE);
        /** Ensure the user cannot accidentally leave the modal  */
        this._createFocusTrap();
        if (this.onShown) {
            this.onShown.emit(this);
        }
    }
    hideModal() {
        this.renderer.setStyle(this._hostElement.nativeElement, 'display', 'none');
        this.showBackdrop(() => {
            if (this.document && this.document.body) {
                this.renderer.removeClass(this.document.body, modalClassNames.OPEN);
            }
            this.resetAdjustments();
            this.resetScrollbar();
            if (this.onHidden) {
                this.onHidden.emit(this);
            }
        });
        if (this._prevFocusedElem) {
            this._prevFocusedElem.focus();
            this._prevFocusedElem = null;
        }
    }
    // todo: original show was calling a callback when done, but we can use promise
    showBackdrop(callback) {
        if (this._isShown && this.config.backdrop && (!this.backdrop || !this.backdrop.instance.isShown)) {
            this.removeBackdrop();
            this.backdrop = this.componentsHelper.appendNextToRoot(ModalBackdropComponent, ModalBackdropOptions, new ModalBackdropOptions({ animate: false }));
            if (this.isAnimated) {
                this.backdrop.instance.isAnimated = this.isAnimated;
                UxHelper.reflow(this.backdrop.instance.element.nativeElement);
            }
            this.backdrop.instance.isShown = true;
            if (!callback) {
                return;
            }
            if (!this.isAnimated) {
                callback();
                return;
            }
            setTimeout(callback, BACKDROP_TRANSITION_DURATION);
        }
        else if (!this._isShown && this.backdrop) {
            this.backdrop.instance.isShown = false;
            let callbackRemove = () => {
                this.removeBackdrop();
                if (callback) {
                    callback();
                }
            };
            if (this.backdrop.instance.isAnimated) {
                this.timerRmBackDrop = setTimeout(callbackRemove, BACKDROP_TRANSITION_DURATION);
            }
            else {
                callbackRemove();
            }
        }
        else if (callback) {
            callback();
        }
    }
    removeBackdrop() {
        if (this.backdrop) {
            this.backdrop.destroy();
            this.backdrop = void 0;
        }
    }
    resetAdjustments() {
        this.renderer.setStyle(this._hostElement.nativeElement, 'paddingLeft', '');
        this.renderer.setStyle(this._hostElement.nativeElement, 'paddingRight', '');
    }
    /** Scroll bar tricks */
    checkScrollbar() {
        this.isBodyOverflowing = this.document.body.clientWidth < window.innerWidth;
        this.scrollbarWidth = this.getScrollbarWidth();
    }
    setScrollbar() {
        if (!this.document) {
            return;
        }
        const fixedEl = this.document.querySelector(modalSelectors.FIXED_CONTENT);
        if (!fixedEl) {
            return;
        }
        const bodyPadding = parseInt(UxHelper.getStyles(fixedEl).paddingRight || 0, 10);
        this.originalBodyPadding = parseInt(this.document.body.style.paddingRight || 0, 10);
        if (this.isBodyOverflowing) {
            this.document.body.style.paddingRight = `${bodyPadding + this.scrollbarWidth}px`;
        }
    }
    resetScrollbar() {
        this.document.body.style.paddingRight = this.originalBodyPadding;
    }
    // thx d.walsh
    getScrollbarWidth() {
        const scrollDiv = this.renderer.createElement('div');
        this.renderer.appendChild(document.body, scrollDiv);
        scrollDiv.className = modalClassNames.SCROLLBAR_MEASURER;
        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.renderer.removeChild(document.body, scrollDiv);
        return scrollbarWidth;
    }
    _createFocusTrap() {
        // Grab a reference to the modal's host element
        const containerElement = this._hostElement.nativeElement;
        // Grab a reference to the first and last focusable elements within the modal
        const [first, last] = getFocusableBoundaryElements(containerElement);
        if (first && last) {
            focusTrap(containerElement, this.onHidden);
            first.focus(); // Set focus to the first focusable element.
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$1.UxHelper }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ModalDirective, selector: "[data-uxd-modal]", inputs: { config: "config" }, outputs: { onShow: "onShow", onShown: "onShown", onHide: "onHide", onHidden: "onHidden" }, host: { listeners: { "click": "onClick($event)", "keydown.esc": "onEsc()" } }, exportAs: ["modal"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-modal]',
                    exportAs: 'modal'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$1.UxHelper }]; }, propDecorators: { config: [{
                type: Input
            }], onShow: [{
                type: Output
            }], onShown: [{
                type: Output
            }], onHide: [{
                type: Output
            }], onHidden: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onEsc: [{
                type: HostListener,
                args: ['keydown.esc']
            }] } });

class UxModalHelper {
    handleClick(event, element) {
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UxModalHelper, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UxModalHelper }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UxModalHelper, decorators: [{
            type: Injectable
        }] });

//istanbul ignore next
class ModalComponent extends ModalDirective {
    set ariaLabelledBy(ariaLabelledBy) {
        this._ariaLabelledBy = ariaLabelledBy;
    }
    get ariaLabelledBy() {
        return this._ariaLabelledBy;
    }
    set ariaDescribedBy(ariaDescribedBy) {
        this._ariaDescribedBy = ariaDescribedBy;
    }
    get ariaDescribedBy() {
        return this._ariaDescribedBy;
    }
    constructor(element, renderer, uxHlpr, _modalHlpr) {
        super(element, renderer, uxHlpr);
        this._modalHlpr = _modalHlpr;
        this.onClose = new EventEmitter();
    }
    handleClose() {
        this.hide();
        this.onClose.emit();
    }
    ngAfterViewInit() {
        if (!this.modal || !this.modal.id) {
            console.error("ModalComponent requires id");
        }
        this._config = this._config || this.getConfig();
        this.renderer.addClass(this._hostElement.nativeElement, 'modal');
        this.renderer.addClass(this._hostElement.nativeElement, 'fade');
        this._ariaLabelledBy += `${this.modal.id}+'_title`;
        if (this.modal && this.modal.cssClass) {
            this.renderer.addClass(this._hostElement.nativeElement, this.modal.cssClass);
        }
        if (this.modal && this.modal.modalType === 'error') {
            this.renderer.addClass(this._hostElement.nativeElement, 'ant-error-modal');
        }
        else if (this.modal && this.modal.modalType === 'fullscreen') {
            this.renderer.addClass(this._hostElement.nativeElement, 'ant-fullscreen-modal');
        }
    }
    _handleEscKeydown(event) {
        this.hide();
        event.preventDefault();
    }
    handleAnchorClicks(event) {
        return this._modalHlpr.handleClick(event, this._hostElement);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$1.UxHelper }, { token: UxModalHelper }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ModalComponent, selector: "[data-uxd-modal-cmp]", inputs: { modal: "modal", ariaLabelledBy: ["aria-labelledby", "ariaLabelledBy"], ariaDescribedBy: ["aria-describedby", "ariaDescribedBy"] }, outputs: { onClose: "onClose" }, host: { listeners: { "keydown.esc": "_handleEscKeydown($event)", "click": "handleAnchorClicks($event)" } }, viewQueries: [{ propertyName: "titleElement", first: true, predicate: ["title"], descendants: true }], exportAs: ["modal"], usesInheritance: true, ngImport: i0, template: `
  <div class="modal-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-aria-describedby]="ariaDescribedBy"
      [attr.aria-labelledby]="ariaLabelledBy ">
    <div class="modal-content">
      <div class="modal-top">
        <div class="modal-header">
          <button
            *ngIf="!modal?.hideClose"
            [id]="modal.id+'_close'"
            type="button" class="close"
            data-dismiss="modal" aria-label="Close"
            data-autofocus (click)="handleClose()"
            [attr.data-analytics]="modal?.closeAnalytics">
            <span class="fa fa-remove"></span>
          </button>
          <h2 #title class="modal-title"
            [id]="modal.id+'_title'"
            [innerHTML]="modal?.title"> </h2>
        </div>
        <div class="modal-body">
          <ng-content select=".modal-component-body"></ng-content>
          <span *ngIf="modal?.content" [id]="modal.id+'_body'" [innerHTML]="modal?.content"></span>
        </div>
      </div>
      <div class="modal-footer">
        <ng-content select=".modal-component-footer"></ng-content>
      </div>

    </div>
  </div>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "[data-uxd-modal-cmp]",
                    exportAs: "modal",
                    template: `
  <div class="modal-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-aria-describedby]="ariaDescribedBy"
      [attr.aria-labelledby]="ariaLabelledBy ">
    <div class="modal-content">
      <div class="modal-top">
        <div class="modal-header">
          <button
            *ngIf="!modal?.hideClose"
            [id]="modal.id+'_close'"
            type="button" class="close"
            data-dismiss="modal" aria-label="Close"
            data-autofocus (click)="handleClose()"
            [attr.data-analytics]="modal?.closeAnalytics">
            <span class="fa fa-remove"></span>
          </button>
          <h2 #title class="modal-title"
            [id]="modal.id+'_title'"
            [innerHTML]="modal?.title"> </h2>
        </div>
        <div class="modal-body">
          <ng-content select=".modal-component-body"></ng-content>
          <span *ngIf="modal?.content" [id]="modal.id+'_body'" [innerHTML]="modal?.content"></span>
        </div>
      </div>
      <div class="modal-footer">
        <ng-content select=".modal-component-footer"></ng-content>
      </div>

    </div>
  </div>`
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$1.UxHelper }, { type: UxModalHelper }]; }, propDecorators: { modal: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input,
                args: ['aria-labelledby']
            }], ariaDescribedBy: [{
                type: Input,
                args: ['aria-describedby']
            }], onClose: [{
                type: Output
            }], titleElement: [{
                type: ViewChild,
                args: ["title"]
            }], _handleEscKeydown: [{
                type: HostListener,
                args: ['keydown.esc', ['$event']]
            }], handleAnchorClicks: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

//istanbul ignore next
class OpenModalDirective {
    constructor(_uxHlpr, templateUrl) {
        this._uxHlpr = _uxHlpr;
        this.templateUrl = templateUrl;
        this._openModalEvent = this._uxHlpr.getUxEvents(UxEvents[UxEvents.OPEN_GLOBAL_MODAL]);
        if (!templateUrl) {
            console.error('OpenModalDirective missing data-modal-html-template attribute');
        }
    }
    onClick(button, ctrlKey, metaKey) {
        if (this.templateUrl) {
            this._openModalEvent.emit({
                modalTemplateUrl: this.templateUrl
            });
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OpenModalDirective, deps: [{ token: i1$1.UxHelper }, { token: 'data-modal-html-template', attribute: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: OpenModalDirective, selector: "[data-uxd-open-modal-dir]", host: { listeners: { "click": "onClick($event.button,$event.ctrlKey,$event.metaKey)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OpenModalDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-open-modal-dir]'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.UxHelper }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ['data-modal-html-template']
                }] }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey']]
            }] } });

class ModalDepModule {
    static forRoot() {
        return {
            ngModule: ModalDepModule,
            providers: []
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDepModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ModalDepModule, declarations: [ModalComponent, ModalBackdropComponent, ModalDirective, OpenModalDirective], imports: [CommonModule], exports: [ModalComponent, ModalBackdropComponent, ModalDirective, OpenModalDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDepModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDepModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ModalComponent, ModalBackdropComponent, ModalDirective, OpenModalDirective],
                    exports: [ModalComponent, ModalBackdropComponent, ModalDirective, OpenModalDirective]
                }]
        }] });

class LinkedListComponent {
    ngOnInit() {
        // init
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LinkedListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LinkedListComponent, selector: "[data-uxd-linked-list-block]", inputs: { linkedListBlock: "linkedListBlock" }, ngImport: i0, template: `
            <div class="row footer-links">
                <div class="col-xs-6" *ngFor="let item of linkedListBlock.item">
                  <h4 class="headline-half">{{item.headline}}</h4>
                  <ul>
                    <li *ngFor="let link of item.link">
                      <a href="{{link.url}}" innerHTML="{{link.title}}<br/><small>{{link.description}}</small>"></a>
                    </li>
                  </ul>
                </div>
            </div>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LinkedListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-linked-list-block]',
                    template: `
            <div class="row footer-links">
                <div class="col-xs-6" *ngFor="let item of linkedListBlock.item">
                  <h4 class="headline-half">{{item.headline}}</h4>
                  <ul>
                    <li *ngFor="let link of item.link">
                      <a href="{{link.url}}" innerHTML="{{link.title}}<br/><small>{{link.description}}</small>"></a>
                    </li>
                  </ul>
                </div>
            </div>`
                }]
        }], propDecorators: { linkedListBlock: [{
                type: Input
            }] } });

class ListModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ListModule, declarations: [LinkedListComponent], imports: [CommonModule], exports: [LinkedListComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [LinkedListComponent],
                    exports: [LinkedListComponent]
                }]
        }] });

class UxDeprecatedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UxDeprecatedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: UxDeprecatedModule, declarations: [CalloutBlockComponent], imports: [CommonModule, AlertCmpModule, AccordianCmpDepModule, CardModule, ListModule, ModalDepModule], exports: [AlertCmpModule, AccordianCmpDepModule, CardModule, ListModule, ModalDepModule, CalloutBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UxDeprecatedModule, imports: [CommonModule, AlertCmpModule, AccordianCmpDepModule, CardModule, ListModule, ModalDepModule, AlertCmpModule, AccordianCmpDepModule, CardModule, ListModule, ModalDepModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UxDeprecatedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, AlertCmpModule, AccordianCmpDepModule, CardModule, ListModule, ModalDepModule],
                    declarations: [CalloutBlockComponent],
                    exports: [AlertCmpModule, AccordianCmpDepModule, CardModule, ListModule, ModalDepModule, CalloutBlockComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AccordianCmpDepModule, AlertCmpModule, AlertComponent, BlockToggleDirective, CalloutBlockComponent, CardComponent, CardModule, LinkedListComponent, ListModule, ModalBackdropComponent, ModalBackdropOptions, ModalComponent, ModalDepModule, ModalDirective, OpenModalDirective, RowToggleDirective, UxDeprecatedModule, UxModalHelper, modalClassNames, modalConfigDefaults, modalSelectors };
